// Used in login-routing.module.ts

// Angular
import { Injectable } from "@angular/core";
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";

// Services/Types/Helpers
import { LocalStorage } from "#services/local-storage.service";
import { AuthHelper } from "#core/helpers/auth.helper";

// RXJS/Store
import { Store } from "@ngrx/store";
import * as LoginStore from "../../login/store";

@Injectable()
export class AutoLoginGuardService  {
    constructor(
        private authHelper: AuthHelper,
        private router: Router,
        private loginStore: Store<LoginStore.UserState>,
        private localStorage: LocalStorage
    ) {}

    // used on parent routes
    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): boolean {
        return this.autoLogin();
    }

    // used on child routes
    canActivateChild(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): boolean {
        return this.autoLogin();
    }

    /**
     * @method autoLogin
     * @description auto logs in user if they have a profile in local storage
     * @returns {boolean}
     */
    autoLogin(): boolean {
        // Use local storage user profile to determine if user is logged in
        const localStorageProfileData = this.localStorage.get("userProfile");

        // User has no profile data, means they aren't logged in. Let them see the page
        if (
            localStorageProfileData === undefined ||
            localStorageProfileData === null
        ) {
            return true;
        } else {
            // User is logged in so better redirect them to the correct page
            // Check if User has an unexpired authentication token, if so redirect
            return true;
        }
    }
}
